import axios from 'axios';
import { GET_VISITORS, GET_SPECIFIC_VISITOR, ADD_VISITOR, EDIT_VISITOR, DELETE_VISITOR, CLEAR_VISITORS, VISITORS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IVisitor } from '../../types/interfaces';
import store from '../store';

export const getVisitors = (duration: any) => (dispatch: Function, getState: Function) => {
  // dispatch(setVisitorsLoading());
  dispatch({
    type: VISITORS_LOADING
  });
  axios
    .get('/api/visitors', {...tokenConfig(getState), params: {duration}})
    .then(res =>
      dispatch({
        type: GET_VISITORS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getVisitorById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: VISITORS_LOADING
  });
  axios
    .get('/api/visitors/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_VISITOR,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addVisitor = (visitor: IVisitor, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/visitors', {visitor}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ADD_VISITOR,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editVisitor = (visitor: IVisitor, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/visitors/edit', {visitor}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_VISITOR,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteVisitor = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/visitors/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_VISITOR,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearVisitors = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_VISITORS
  })
};